import Vue from 'vue'


// Register Bootstrap-Vue components
import {BAlert} from 'bootstrap-vue/esm/components/alert/alert'
import {BBadge} from 'bootstrap-vue/esm/components/badge/badge'
import {BBreadcrumb} from 'bootstrap-vue/esm/components/breadcrumb/breadcrumb'
import {BBreadcrumbItem} from 'bootstrap-vue/esm/components/breadcrumb/breadcrumb-item'
import {BBreadcrumbLink} from 'bootstrap-vue/esm/components/breadcrumb/breadcrumb-link'
import {BButton} from 'bootstrap-vue/esm/components/button/button'
import {BButtonClose} from 'bootstrap-vue/esm/components/button/button-close'
import {BButtonGroup} from 'bootstrap-vue/esm/components/button-group/button-group'
import {BButtonToolbar} from 'bootstrap-vue/esm/components/button-toolbar/button-toolbar'
import {BCard} from 'bootstrap-vue/esm/components/card/card'
import {BCardBody} from 'bootstrap-vue/esm/components/card/card-body'
import {BCardFooter} from 'bootstrap-vue/esm/components/card/card-footer'
import {BCardGroup} from 'bootstrap-vue/esm/components/card/card-group'
import {BCardHeader} from 'bootstrap-vue/esm/components/card/card-header'
import {BCardImg} from 'bootstrap-vue/esm/components/card/card-img'
import {BCarousel} from 'bootstrap-vue/esm/components/carousel/carousel'
import {BCarouselSlide} from 'bootstrap-vue/esm/components/carousel/carousel-slide'
import {BCol} from 'bootstrap-vue/esm/components/layout/col'
import {BCollapse} from 'bootstrap-vue/esm/components/collapse/collapse'
import {BContainer} from 'bootstrap-vue/esm/components/layout/container'
import {BDropdown} from 'bootstrap-vue/esm/components/dropdown/dropdown'
import {BDropdownDivider} from 'bootstrap-vue/esm/components/dropdown/dropdown-divider'
import {BDropdownHeader} from 'bootstrap-vue/esm/components/dropdown/dropdown-header'
import {BDropdownItem} from 'bootstrap-vue/esm/components/dropdown/dropdown-item'
import {BDropdownItemButton} from 'bootstrap-vue/esm/components/dropdown/dropdown-item-button'
import {BEmbed} from 'bootstrap-vue/esm/components/embed/embed'
import {BForm} from 'bootstrap-vue/esm/components/form/form'
import {BFormCheckbox} from 'bootstrap-vue/esm/components/form-checkbox/form-checkbox'
import {BFormCheckboxGroup} from 'bootstrap-vue/esm/components/form-checkbox/form-checkbox-group'
import {BFormFile} from 'bootstrap-vue/esm/components/form-file/form-file'
import {BFormGroup} from 'bootstrap-vue/esm/components/form-group/form-group'
import {BFormInput} from 'bootstrap-vue/esm/components/form-input/form-input'
import {BFormInvalidFeedback} from 'bootstrap-vue/esm/components/form/form-invalid-feedback'
import {BFormRadio} from 'bootstrap-vue/esm/components/form-radio/form-radio'
import {BFormRadioGroup} from 'bootstrap-vue/esm/components/form-radio/form-radio-group'
import {BFormRow} from 'bootstrap-vue/esm/components/layout/form-row'
import {BFormSelect} from 'bootstrap-vue/esm/components/form-select/form-select'
import {BFormText} from 'bootstrap-vue/esm/components/form/form-text'
import {BFormTextarea} from 'bootstrap-vue/esm/components/form-textarea/form-textarea'
import {BFormValidFeedback} from 'bootstrap-vue/esm/components/form/form-valid-feedback'
import {BImg} from 'bootstrap-vue/esm/components/image/img'
import {BImgLazy} from 'bootstrap-vue/esm/components/image/img-lazy'
import {BInputGroup} from 'bootstrap-vue/esm/components/input-group/input-group'
import {BInputGroupAddon} from 'bootstrap-vue/esm/components/input-group/input-group-addon'
import {BInputGroupAppend} from 'bootstrap-vue/esm/components/input-group/input-group-append'
import {BInputGroupPrepend} from 'bootstrap-vue/esm/components/input-group/input-group-prepend'
import {BInputGroupText} from 'bootstrap-vue/esm/components/input-group/input-group-text'
import {BJumbotron} from 'bootstrap-vue/esm/components/jumbotron/jumbotron'
import {BLink} from 'bootstrap-vue/esm/components/link/link'
import {BListGroup} from 'bootstrap-vue/esm/components/list-group/list-group'
import {BListGroupItem} from 'bootstrap-vue/esm/components/list-group/list-group-item'
import {BMedia} from 'bootstrap-vue/esm/components/media/media'
import {BMediaAside} from 'bootstrap-vue/esm/components/media/media-aside'
import {BMediaBody} from 'bootstrap-vue/esm/components/media/media-body'
import {BModal} from 'bootstrap-vue/esm/components/modal/modal'
import {BNav} from 'bootstrap-vue/esm/components/nav/nav'
import {BNavbar} from 'bootstrap-vue/esm/components/navbar/navbar'
import {BNavbarBrand} from 'bootstrap-vue/esm/components/navbar/navbar-brand'
import {BNavbarNav} from 'bootstrap-vue/esm/components/navbar/navbar-nav'
import {BNavbarToggle} from 'bootstrap-vue/esm/components/navbar/navbar-toggle'
import {BNavForm} from 'bootstrap-vue/esm/components/nav/nav-form'
import {BNavItem} from 'bootstrap-vue/esm/components/nav/nav-item'
import {BNavItemDropdown} from 'bootstrap-vue/esm/components/nav/nav-item-dropdown'
import {BNavText} from 'bootstrap-vue/esm/components/nav/nav-text'
import {BPagination} from 'bootstrap-vue/esm/components/pagination/pagination'
import {BPaginationNav} from 'bootstrap-vue/esm/components/pagination-nav/pagination-nav'
import {BPopover} from 'bootstrap-vue/esm/components/popover/popover'
import {BProgress} from 'bootstrap-vue/esm/components/progress/progress'
import {BProgressBar} from 'bootstrap-vue/esm/components/progress/progress-bar'
import {BRow} from 'bootstrap-vue/esm/components/layout/row'
import {BSpinner} from 'bootstrap-vue/esm/components/spinner/spinner'
import {BTab} from 'bootstrap-vue/esm/components/tabs/tab'
import {BTable} from 'bootstrap-vue/esm/components/table/table'
import {BTabs} from 'bootstrap-vue/esm/components/tabs/tabs'
import {BTooltip} from 'bootstrap-vue/esm/components/tooltip/tooltip'

Vue.component('b-alert', BAlert)
Vue.component('b-badge', BBadge)
Vue.component('b-breadcrumb', BBreadcrumb)
Vue.component('b-breadcrumb-item', BBreadcrumbItem)
Vue.component('b-breadcrumb-link', BBreadcrumbLink)
Vue.component('b-button', BButton)
Vue.component('b-button-close', BButtonClose)
Vue.component('b-button-group', BButtonGroup)
Vue.component('b-button-toolbar', BButtonToolbar)
Vue.component('b-card', BCard)
Vue.component('b-card-body', BCardBody)
Vue.component('b-card-footer', BCardFooter)
Vue.component('b-card-group', BCardGroup)
Vue.component('b-card-header', BCardHeader)
Vue.component('b-card-image', BCardImg)
Vue.component('b-carousel', BCarousel)
Vue.component('b-carousel-slide', BCarouselSlide)
Vue.component('b-col', BCol)
Vue.component('b-collapse', BCollapse)
Vue.component('b-container', BContainer)
Vue.component('b-dropdown', BDropdown)
Vue.component('b-dropdown-divider', BDropdownDivider)
Vue.component('b-dropdown-header', BDropdownHeader)
Vue.component('b-dropdown-item', BDropdownItem)
Vue.component('b-dropdown-item-button', BDropdownItemButton)
Vue.component('b-embed', BEmbed)
Vue.component('b-form', BForm)
Vue.component('b-form-checkbox', BFormCheckbox)
Vue.component('b-form-checkbox-group', BFormCheckboxGroup)
Vue.component('b-form-file', BFormFile)
Vue.component('b-form-group', BFormGroup)
Vue.component('b-form-input', BFormInput)
Vue.component('b-form-invalid-feedback', BFormInvalidFeedback)
Vue.component('b-form-radio', BFormRadio)
Vue.component('b-form-radio-group', BFormRadioGroup)
Vue.component('b-form-row', BFormRow)
Vue.component('b-form-row', BFormRow)
Vue.component('b-form-select', BFormSelect)
Vue.component('b-form-text', BFormText)
Vue.component('b-form-textarea', BFormTextarea)
Vue.component('b-form-valid-feedback', BFormValidFeedback)
Vue.component('b-image', BImg)
Vue.component('b-image-lazy', BImgLazy)
Vue.component('b-input-group', BInputGroup)
Vue.component('b-input-group-addon', BInputGroupAddon)
Vue.component('b-input-group-append', BInputGroupAppend)
Vue.component('b-input-group-prepend', BInputGroupPrepend)
Vue.component('b-input-group-text', BInputGroupText)
Vue.component('b-jumbotron', BJumbotron)
Vue.component('b-link', BLink)
Vue.component('b-list-group', BListGroup)
Vue.component('b-list-group-item', BListGroupItem)
Vue.component('b-media', BMedia)
Vue.component('b-media-aside', BMediaAside)
Vue.component('b-media-body', BMediaBody)
Vue.component('b-modal', BModal)
Vue.component('b-nav', BNav)
Vue.component('b-nav-form', BNavForm)
Vue.component('b-nav-item', BNavItem)
Vue.component('b-nav-item-dropdown', BNavItemDropdown)
Vue.component('b-nav-text', BNavText)
Vue.component('b-navbar', BNavbar)
Vue.component('b-navbar-brand', BNavbarBrand)
Vue.component('b-navbar-nav', BNavbarNav)
Vue.component('b-navbar-toggle', BNavbarToggle)
Vue.component('b-pagination', BPagination)
Vue.component('b-pagination-nav', BPaginationNav)
Vue.component('b-popover', BPopover)
Vue.component('b-progress', BProgress)
Vue.component('b-progress-bar', BProgressBar)
Vue.component('b-row', BRow)
Vue.component('b-spinner', BSpinner)
Vue.component('b-tab', BTab)
Vue.component('b-table', BTable)
Vue.component('b-tabs', BTabs)
Vue.component('b-tooltip', BTooltip)


// Register Bootstrap-Vue directives
import {VBHover} from 'bootstrap-vue/esm/directives/hover'
import {VBModal} from 'bootstrap-vue/esm/directives/modal'
import {VBPopover} from 'bootstrap-vue/esm/directives/popover'
import {VBScrollspy} from 'bootstrap-vue/esm/directives/scrollspy'
import {VBToggle} from 'bootstrap-vue/esm/directives/toggle'
import {VBTooltip} from 'bootstrap-vue/esm/directives/tooltip'
import {VBVisible} from 'bootstrap-vue/esm/directives/visible'

Vue.directive('b-hover', VBHover)
Vue.directive('b-modal', VBModal)
Vue.directive('b-popover', VBPopover)
Vue.directive('b-scrollspy', VBScrollspy)
Vue.directive('b-toggle', VBToggle)
Vue.directive('b-tooltip', VBTooltip)
Vue.directive('b-visible', VBVisible)


// Register Shards-Vue Components
import dAlert from 'shards-vue/src/components/alert/Alert'
import dBadge from 'shards-vue/src/components/badge/Badge'
import dBreadcrumb from 'shards-vue/src/components/breadcrumb/Breadcrumb'
import dBreadcrumbItem from 'shards-vue/src/components/breadcrumb/BreadcrumbItem'
import dBreadcrumbLink from 'shards-vue/src/components/breadcrumb/BreadcrumbLink'
import dButton from 'shards-vue/src/components/button/Button'
import dButtonClose from 'shards-vue/src/components/button/ButtonClose'
import dButtonGroup from 'shards-vue/src/components/button-group/ButtonGroup'
import dButtonToolbar from 'shards-vue/src/components/button-toolbar/ButtonToolbar'
import dCard from 'shards-vue/src/components/card/Card'
import dCardBody from 'shards-vue/src/components/card/CardBody'
import dCardFooter from 'shards-vue/src/components/card/CardFooter'
import dCardGroup from 'shards-vue/src/components/card/CardGroup'
import dCardHeader from 'shards-vue/src/components/card/CardHeader'
import dCardImg from 'shards-vue/src/components/card/CardImg'
import dCollapse from 'shards-vue/src/components/collapse/Collapse'
import dCol from 'shards-vue/src/components/container/Col'
import dContainer from 'shards-vue/src/components/container/Container'
import dRow from 'shards-vue/src/components/container/Row'
import dDatepicker from 'shards-vue/src/components/datepicker/Datepicker'
import dDropdown from 'shards-vue/src/components/dropdown/Dropdown'
import dDropdownDivider from 'shards-vue/src/components/dropdown/DropdownDivider'
import dDropdownHeader from 'shards-vue/src/components/dropdown/DropdownHeader'
import dDropdownItem from 'shards-vue/src/components/dropdown/DropdownItem'
import dEmbed from 'shards-vue/src/components/embed/Embed'
import dForm from 'shards-vue/src/components/form/Form'
import dFormFeedback from 'shards-vue/src/components/form/FormFeedback'
import dFormInvalidFeedback from 'shards-vue/src/components/form/FormInvalidFeedback'
import dFormRow from 'shards-vue/src/components/form/FormRow'
import dFormText from 'shards-vue/src/components/form/FormText'
import dFormValidFeedback from 'shards-vue/src/components/form/FormValidFeedback'
import dFormCheckbox from 'shards-vue/src/components/form-checkbox/FormCheckbox'
import dFormInput from 'shards-vue/src/components/form-input/FormInput'
import dFormRadio from 'shards-vue/src/components/form-radio/FormRadio'
import dFormSelect from 'shards-vue/src/components/form-select/FormSelect'
import dFormTextarea from 'shards-vue/src/components/form-textarea/FormTextarea'
import dImage from 'shards-vue/src/components/image/Image'
import dInputGroup from 'shards-vue/src/components/input-group/InputGroup'
import dInputGroupAddon from 'shards-vue/src/components/input-group/InputGroupAddon'
import dInputGroupText from 'shards-vue/src/components/input-group/InputGroupText'
import dLink from 'shards-vue/src/components/link/Link'
import dListGroup from 'shards-vue/src/components/list-group/ListGroup'
import dListGroupItem from 'shards-vue/src/components/list-group/ListGroupItem'
import dModal from 'shards-vue/src/components/modal/Modal'
import dModalBody from 'shards-vue/src/components/modal/ModalBody'
import dModalFooter from 'shards-vue/src/components/modal/ModalFooter'
import dModalHeader from 'shards-vue/src/components/modal/ModalHeader'
import dModalTitle from 'shards-vue/src/components/modal/ModalTitle'
import dNav from 'shards-vue/src/components/nav/Nav'
import dNavItem from 'shards-vue/src/components/nav/NavItem'
import dNavText from 'shards-vue/src/components/nav/NavText'
import dNavbar from 'shards-vue/src/components/navbar/Navbar'
import dNavbarBrand from 'shards-vue/src/components/navbar/NavbarBrand'
import dNavbarNav from 'shards-vue/src/components/navbar/NavbarNav'
import dNavbarToggle from 'shards-vue/src/components/navbar/NavbarToggle'
import dPopover from 'shards-vue/src/components/popover/Popover'
import dProgress from 'shards-vue/src/components/progress/Progress'
import dProgressBar from 'shards-vue/src/components/progress/ProgressBar'
import dSlider from 'shards-vue/src/components/slider/Slider'
import dTab from 'shards-vue/src/components/tabs/Tab'
import dTabs from 'shards-vue/src/components/tabs/Tabs'
import dTooltip from 'shards-vue/src/components/tooltip/Tooltip'


Vue.component('d-alert', dAlert)
Vue.component('d-badge', dBadge)
Vue.component('d-breadcrumb', dBreadcrumb)
Vue.component('d-breadcrumb-item', dBreadcrumbItem)
Vue.component('d-breadcrumb-link', dBreadcrumbLink)
Vue.component('d-button', dButton)
Vue.component('d-button-close', dButtonClose)
Vue.component('d-button-group', dButtonGroup)
Vue.component('d-button-toolbar', dButtonToolbar)
Vue.component('d-card', dCard)
Vue.component('d-card-body', dCardBody)
Vue.component('d-card-footer', dCardFooter)
Vue.component('d-card-group', dCardGroup)
Vue.component('d-card-header', dCardHeader)
Vue.component('d-card-img', dCardImg)
Vue.component('d-collapse', dCollapse)
Vue.component('d-col', dCol)
Vue.component('d-container', dContainer)
Vue.component('d-row', dRow)
Vue.component('d-datepicker', dDatepicker)
Vue.component('d-dropdown', dDropdown)
Vue.component('d-dropdown-divider', dDropdownDivider)
Vue.component('d-dropdown-header', dDropdownHeader)
Vue.component('d-dropdown-item', dDropdownItem)
Vue.component('d-embed', dEmbed)
Vue.component('d-form', dForm)
Vue.component('d-form-feedback', dFormFeedback)
Vue.component('d-form-invalid-feedback', dFormInvalidFeedback)
Vue.component('d-form-row', dFormRow)
Vue.component('d-form-text', dFormText)
Vue.component('d-form-valid-feedback', dFormValidFeedback)
Vue.component('d-form-checkbox', dFormCheckbox)
Vue.component('d-form-input', dFormInput)
Vue.component('d-form-radio', dFormRadio)
Vue.component('d-form-select', dFormSelect)
Vue.component('d-form-textarea', dFormTextarea)
Vue.component('d-image', dImage)
Vue.component('d-input-group', dInputGroup)
Vue.component('d-input-group-addon', dInputGroupAddon)
Vue.component('d-input-group-text', dInputGroupText)
Vue.component('d-link', dLink)
Vue.component('d-list-group', dListGroup)
Vue.component('d-list-group-item', dListGroupItem)
Vue.component('d-modal', dModal)
Vue.component('d-modal-body', dModalBody)
Vue.component('d-modal-footer', dModalFooter)
Vue.component('d-modal-header', dModalHeader)
Vue.component('d-modal-title', dModalTitle)
Vue.component('d-nav', dNav)
Vue.component('d-nav-item', dNavItem)
Vue.component('d-nav-text', dNavText)
Vue.component('d-navbar', dNavbar)
Vue.component('d-navbar-brand', dNavbarBrand)
Vue.component('d-navbar-nav', dNavbarNav)
Vue.component('d-navbar-toggle', dNavbarToggle)
Vue.component('d-popover', dPopover)
Vue.component('d-progress', dProgress)
Vue.component('d-progress-bar', dProgressBar)
Vue.component('d-slider', dSlider)
Vue.component('d-tab', dTab)
Vue.component('d-tabs', dTabs)
Vue.component('d-tooltip', dTooltip)


// Register Shards-Vue Directives
import VDToggle from 'shards-vue/src/directives/toggle/toggle'
import VDTooltip from 'shards-vue/src/directives/tooltip/tooltip'

Vue.directive('d-toggle', VDToggle)
Vue.directive('d-tooltip', VDTooltip)


// Toasted
import Toasted from 'vue-toasted'

Vue.use(Toasted, {})


// Register custom components
import ButtonSpinner from './components/ButtonSpinner'
import Table from './components/Table'
import Input from './components/Input'
import InfoMessage from './components/InfoMessage'

Vue.component('c-button-spinner', ButtonSpinner)
Vue.component('c-table', Table)
Vue.component('c-input', Input)
Vue.component('c-info-message', InfoMessage)

// Define custom methods
Object.defineProperty(Array.prototype, 'replaceOne', {
  value: function(where, newValue) {
    const copy = [...this]
    const index = this.findIndex(where)

    if (index >= 0)
      copy[index] = newValue

    return copy
  }
})
